<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [xaxis]="chartOptions.xaxis!"
        [yaxis]="chartOptions.yaxis!"
        [legend]="chartOptions.legend!"
        [grid]="chartOptions.grid!"
    ></apx-chart>
</div>